import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Auth0ProviderWithNavigate from "./Auth0ProviderWithNavigate";
import "react-datepicker/dist/react-datepicker.css";
import { ProfileBalanceProvider } from "./context/ProfileContext/ProfileBalanceContext/ProfileBalanceContext";
import { ProfileUserProvider } from "./context/ProfileContext/ProfileUser/ProfileUserContext";
import Registration from "./pages/registrationProfile";
import { store } from "./store/store";
import { Provider } from "react-redux";
import AuthInitializer from "./auth/authInitalizer";
//import 'ag-grid-community/styles/ag-grid.css';
//import 'ag-grid-community/styles/ag-theme-alpine.css';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const Main: React.FC = () => {
  // const { token, loading } = useAuthToken(clientId || "");
  // const [isInitialized, setIsInitialized] = useState<boolean>(false);

  // useEffect(() => {
  //   if (!loading && token) {
  //   } else if (!loading) {
  //   }
  //   setIsInitialized(true);
  // }, [loading, token]);

  // if (loading) {
  //   return <LoadingScreen />;
  // }

  // if (!isInitialized) {
  //   return <LoadingScreen />;
  // }

  return (
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
         <AuthInitializer /> 
        <ProfileUserProvider>
          <Routes>
            <Route path="/completar-perfil" element={<Registration />} />

            <Route
              path="/*"
              element={
                <ProfileBalanceProvider>
                  <App />
                </ProfileBalanceProvider>
              }
            />
          </Routes>
        </ProfileUserProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  );
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Main />
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
